<template>
<div>
    <zm-form label-width="150px" :model="form" label-position="left" :rules="rules" ref="form" style="width: 95%;">
        <zm-form-item label="name" prop="name">
            <div slot="label">
                <tip label="name" id="topic-batchcreateparam-name"></tip>
            </div>
            <zm-input size="small" v-model.trim="form.name" @keyup.native="trimLR" @blur="updateName"></zm-input>
        </zm-form-item>
        <zm-form-item label="dc" prop="dcName">
            <div slot="label">
                <tip label="dc" id="topic-batchcreateparam-dc"></tip>
            </div>
            <zm-select size="small" v-model="form.dcName" @change="onChangeDc" clearable>
                <zm-option v-for="item in dcs" :key="item.id" :value="item.dcName" :label="item.dcName"></zm-option>
            </zm-select>
        </zm-form-item>
        <zm-form-item label="groupName" v-if="form.dcName" prop="groupName">
            <div slot="label">
                <tip label="groupName" id="topic-batchcreateparam-groupName"></tip>
            </div>
            <zm-select size="small" v-model="form.groupName" clearable>
                <zm-option v-for="item in groups" :key="item.groupName" :value="item.groupName"
                    :label="item.groupName + '(currentLoad: ' + item.currentLoad + ')'">
                </zm-option>
            </zm-select>
        </zm-form-item>
        <zm-form-item label="jobStore" v-if="form.dcName">
            <div slot="label">
                <tip label="jobStore" id="topic-batchcreateparam-jobStore"></tip>
            </div>
            <zm-select size="small" v-model="form.jobStore" clearable>
                <zm-option v-for="item in jobStores" :key="item.id" :value="item.id" :label="item.name"></zm-option>
            </zm-select>
        </zm-form-item>
    </zm-form>
</div>
</template>
<script>
import { getDedicatedJobByDc } from '@/api/job'
import { getChannelDcs, getActiveGroups } from '@/api/index'
import tip from 'components/ToolTip/index'
export default {
    name: 'batchCreateParam',
    props: ['index'],
    components: {
        tip
    },
    data () {
        return {
            form: {
                name: '',
                dcName: '',
                groupName: '',
                jobStore: ''
            },
            dcs: [],
            groups: [],
            jobStores: [],
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                dcName: [
                    { required: true, message: 'please select a dc', trigger: 'change' }
                ],
                groupName: [
                    { required: true, message: 'please select a groupName', trigger: 'change' }
                ]
            }
        }
    },
    created () {
        this.fetchDcs()
    },
    methods: {
        updateName () {
            this.$emit('updateName', {
                index: this.index,
                name: this.form.name
            })
        },
        deleteParam () {
            this.$emit('deleteParam', this.index)
        },
        trimLR () {
            this.form.name = this.form.name.replace(/\s+/g, '')
        },
        fetchDcs () {
            getChannelDcs().then(response => {
                this.dcs = response
            })
        },
        onChangeDc () {
            this.fetchGroups()
            this.getDedicatedJobByDc()
        },
        fetchGroups () {
            this.form.groupName = ''
            var dcName = this.form.dcName
            getActiveGroups(false, dcName).then(response => {
                this.groups = response
            })
        },
        getDedicatedJobByDc () {
            this.form.jobStore = null
            if (this.form.dcName) {
                getDedicatedJobByDc(this.form.dcName).then(response => {
                    this.jobStores = response
                })
            }
        }
    }
}
</script>
